import axios from './httpConfig.js'

// 订单列表
export function GetOrderList(param) {
	return axios.post('/voucherorderlist', param)
}
// 订单详情
export function OrderDetail(param) {
	return axios.post('/voucherorder', param)
}
// 新增订单
export function AddOrder(param) {
	return axios.post('/singlesave', param)
}
// 编辑订单
export function EditOrder(param) {
	return axios.post('/singlesave', param)
}
// 删除订单
export function DeleteOrder(param) {
	return axios.post('/vocherdelete', param)
}
// 提交订单
export function SubmitOrder(param) {
	return axios.post('/batchsubmit', param)
}
// 撤回订单
export function RevokeOrder(param) {
	return axios.post('/batchunsubmit', param)
}
// 获取销售组织
export function GetSale(param) {
	return axios.post('/pass1/8', param)
}
// 获取客户名称
export function GetCustomer(param) {
	return axios.post('/merchanlist', param)
}
// 获取客户信息
export function GetCustomerInfo(param) {
	return axios.post('/merchan', param)
}
// 获取项目名称
export function GetProject(param) {
	return axios.post('/projectlist', param)
}
// 获取销售业务员
export function GetMan(param) {
	return axios.post('/staff', param)
}
// 获取物料
export function GetGoods(param) {
	return axios.post('/productlist', param)
}
// 获取现有物料
export function GetXyGoods(param) {
	return axios.post('/xyproductlist', param)
}
// 获取物料详情
export function GetGoodsInfo(param) {
	return axios.post('/product', param)
}
// 获取仓库
export function GetWare(param) {
	return axios.post('/warehouse', param)
}


//----------------组装单-------------------


// 订单列表
export function GetAssOrderList(param) {
	return axios.post('/xtzhlist', param)
}
// 订单详情
export function AssOrderDetail(param) {
	return axios.post('/xtzhorder', param)
}
// 新增订单
export function AssAddOrder(param) {
	return axios.post('/xtzhsave', param)
}
// 编辑订单
export function AssEditOrder(param) {
	return axios.post('/xtzhsave', param)
}
// 删除订单
export function AssDeleteOrder(param) {
	return axios.post('/xtzhdelete', param)
}
// 提交订单
export function AssSubmitOrder(param) {
	return axios.post('/xtzhbatchsubmit', param)
}
// 撤回订单
export function AssRevokeOrder(param) {
	return axios.post('/xtzhbatchunsubmit', param)
}


//----------------请购单-------------------


// 订单列表
export function GetPurOrderList(param) {
	return axios.post('/applyorderlist', param)
}
// 订单详情
export function PurOrderDetail(param) {
	return axios.post('/applyorder', param)
}
// 新增订单
export function PurAddOrder(param) {
	return axios.post('/applyordersave', param)
}
// 编辑订单
export function PurEditOrder(param) {
	return axios.post('/applyordersave', param)
}
// 删除订单
export function PurDeleteOrder(param) {
	return axios.post('/applyorderdelete', param)
}
// 提交订单
export function PurSubmitOrder(param) {
	return axios.post('/applyorderbatchsubmit', param)
}
// 撤回订单
export function PurRevokeOrder(param) {
	return axios.post('/applyorderbatchunsubmit', param)
}


//----------------出库申请单-------------------


// 订单列表
export function GetOutOrderList(param) {
	return axios.post('/pickingrequisitionlist', param)
}
// 订单详情
export function OutOrderDetail(param) {
	return axios.post('/pickingrequisition', param)
}
// 新增订单
export function OutAddOrder(param) {
	return axios.post('/pickingrequisitionsave', param)
}
// 编辑订单
export function OutEditOrder(param) {
	return axios.post('/pickingrequisitionsave', param)
}
// 删除订单
export function OutDeleteOrder(param) {
	return axios.post('/pickingrequisitionderdelete', param)
}
// 提交订单
export function OutSubmitOrder(param) {
	return axios.post('/pickingrequisitionbatchsubmit', param)
}
// 撤回订单
export function OutRevokeOrder(param) {
	return axios.post('/pickingrequisitionbatchunsubmit', param)
}


//----------------顺丰下单-------------------


// 订单列表
export function GetSfOrderList(param) {
	return axios.get('/sf/order/list', param)
}
// 订单详情
export function SfOrderDetail(param) {
	return axios.get('/sf/order/info', param)
}
// 新增订单
export function SfAddOrder(param) {
	return axios.post('/sf/order/create', param)
}
// 编辑订单
export function SfEditOrder(param) {
	return axios.post('/sf/order/edit', param)
}
// 删除订单
export function SfDeleteOrder(param) {
	return axios.get('/sf/order/delete', param)
}
// 修改状态
export function SfStateOrder(param) {
	return axios.get('/sf/order/state', param)
}

// 获取用户
export function SfUser(param) {
	return axios.get('/erp2/user/list', param)
}

// 获取订单类型列表
export function SfExpressType(param) {
	return axios.get('/sf/express/type', param)
}

// 获取可以使用的发货地址
export function SfCompanyAddress(param) {
	return axios.get('/sf/company/address', param)
}

// 获取可以使用的发货地址
export function SfShippingAddress(param) {
	return axios.get('/sf/my/address/list', param)
}
// 获取历史的收获地址
export function SfHistoryAddress(param) {
	return axios.get('/sf/shipping/address', param)
}

// 删除历史收获地址
export function SfHistoryAddressDel(param) {
	return axios.get('/sf/shipping/address/del', param)
}

// 添加历史收获地址
export function SfHistoryAddressAdd(param) {
	return axios.post('/sf/shipping/address/add', param)
}

// 添加历史收获地址
export function SfMyAddressAdd(param) {
	return axios.post('/sf/my/address/create', param)
}

// 获取我的默认发货地址
export function SfDefaultAddress(param) {
	return axios.get('/sf/my/address/default', param)
}

// 获取我的默认发货地址列表
export function SfMyAddressList(param) {
	return axios.get('/sf/my/address/list', param)
}

// 设置我的默认发货地址
export function SfSetDefaultAddress(param) {
	return axios.get('/sf/my/address/set/default', param)
}

// 删除我的默认发货地址
export function SfMyAddressDel(param) {
	return axios.get('/sf/my/address/delete', param)
}

// 打印机列表
export function SfPrinterList(param) {
	return axios.get('/sf/print/list', param)
}

//读取用户默认配置
export function SfUserConfig(param) {
	return axios.get('/erp2/user/get/default', param)	
}

// 打印机
export function SfPrinterPdf(param) {
	return axios.get('/sf/order/print/pdf', param)
}

// 分割地址
export function SfAddressSplit(param) {
	return axios.post('/tools/address/split', param)
}

//历史发货货物描述
export function SfHistoryGoodsDesc(param) {
	return axios.get('/sf/goods/desc/list', param)
}

// 获取路由信息
export function GetRouterInfo(param) {
	return axios.get('/sf/express/order/route/list', param)
}


// 获取订单金额汇总
export function GetOrderMoneySum(param) {
	return axios.get('/sf/order/get/money/sum', param)
}


// 获取sf接口路由数据列表
export function GetSfOrderRouteList(param) {
	return axios.get('/sf/express/get/order/route/list', param)
}

// 获取sf订单预计派送时间
export function GetSfOrderTimer(param) {
	return axios.get('/sf/express/get/order/time', param)
}

// 获取sf订单物流状态
export function GetSfOrderRouteLastStatus(param) {
	return axios.get('/sf/express/order/route/status', param)
}

// 添加 SN 号
export function AddSn(param) {
	return axios.post('/sf/print/sn/add', param)
}

// 新增打印机昵称
export function SfAddPrinterNickname(param) {
	return axios.post('/sf/print/add', param)
}

// 编辑打印机昵称
export function SfEditPrinterNickname(param) {
	return axios.post('/sf/print/update', param)
}

// 删除打印机昵称
export function SfDeletePrinterNickname(param) {
	return axios.get('/sf/print/delete', param)
}

// 获取打印服务器列表
export function SfPrintServerList(param) {
	return axios.get('/sf/print/server/list', param)
}

// 获取运单打印进度
export function SfGetOrderPrintPress(param) {
	return axios.get('/sf/order/get/print/press', param)
}


// 删除公司地址
export function sfCompanyAddressDel(param) {
	return axios.get('/sf/company/address/del', param)
}

// 设置公司默认地址
export function sfCompanyAddressDefault(param) {
	return axios.get('/sf/company/address/set/default', param)
}

// 添加公司地址
export function sfCompanyAddressAdd(param) {
	return axios.post('/sf/company/address/add', param)
}

// 更新公司地址
export function sfCompanyAddressUpdate(param) {
	return axios.post('/sf/company/address/update', param)
}

// 更新公司地址
export function erp2QueryPenaltyBasicParamList(param) {
	return axios.get('/erp2/penalty/query/basic/list', param)
}
// ------------------------------------------------------

// 获取用户信息
// export function GetUserInfo(param) {
// 	return axios.get('/erp2/user/info', param)
// }